import './stopwatch.css'
import { useState } from 'react';
import BtnStopwatch from './util/BtnStopwatch';


export function Stopwatch() {
    const [hour, setHour] = useState({ h: 0 });
    const [minute, setMinute] = useState({ m: 0 });
    const [second, setSecond] = useState({ s: 0 });
    const [started, setStarted] = useState();
    const [status, setStatus] = useState({ i: 0 });    

    var changeSecond = second.s
    var changeMinute = minute.m
    var changeHour = hour.h
    var changeStatus = status.i

    const start = () => {
        if (changeStatus === 0 || changeStatus === 2) {
            run();
            setStarted(setInterval(run, 1000));
            setStatus({ i: 1 })
        }
    };
    const run = () => {
        if (changeSecond === 59) {
            changeMinute++;
        }
        if (changeMinute === 59) {
            changeHour++;
        }

        if(changeSecond === 59 || changeMinute === 59){
            if (changeSecond === 59){
                changeSecond = 0;
            }
            if (changeMinute === 59){
                changeMinute = 0;
            }
        } else {
            changeSecond++;
        }
        return (setSecond({ s: changeSecond, }), setMinute({ m: changeMinute }), setHour({ h: changeHour }))
    }
    const stop = () => {
        clearInterval(started);
        setStatus({ i: 2 })
    };

    const reset = () => {
        clearInterval(started);
        setHour({ h: 0 })
        setMinute({ m: 0 })
        setSecond({ s: 0 })
        setStatus({ i: 0 })
    }

    return (
        <>
            <div className='main'>
                <h1 >Marcando o texto em seu tempo</h1>
                <div className='timer'>
                    <span>{changeHour.toString().padStart(2, "0")}</span>:<span>{changeMinute.toString().padStart(2, "0")}</span>:<span>{changeSecond.toString().padStart(2, "0")}</span>
                </div>
                
                <BtnStopwatch status={changeStatus} hour={changeHour.toString().padStart(2, "0")} minute={changeMinute.toString().padStart(2, "0")} second={changeSecond.toString().padStart(2, "0")} reset={reset} stop={stop} start={start} />
            </div>
        </>
    );
}
